import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CreateServiceLevel from './../CreateServiceLevel';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import MasterService from './../../../services/masterdata.service';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../shared/constants/constant';
import Util from './../../../../shared/util/util';

export default {
  name: 'service-level-listing',
  components: {
    BasicSelect,
    CreateServiceLevel,
    CustomExpandableTable,
    Pagination,
    VueElementLoading
  },
  props: [],
  data: function() {
    return {
      //for filter
      isLoading:false,
      totalPage:0,
      totalCount:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      servicelevel: '',
      servicelevelSearch: '',
      showlist: true,
      currentPage: 1,
      pageCount: 0,
      pageNo: 0,
      totalrows: 0,
      offset: 0,
      type:'SERVICE_LEVEL_MASTER',
      tableColumn: [ 'Template Name', 'Template Description','Route Mode','Service Type','Created By','Created Date','Last Modified By','Last Modified Date','Status','Action'],
      innerTableColumn: [],
      tableItems: [],
      apiListingData:[],
      selectedEditRow:null,
      status:"",
      statusSearch:"",
      statusSearch:"",
      statuslist:[{
        value : "1",
        text : 'Active'
      },{
        value : "0",
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
    }
  },
  computed: {
  },
  mounted() {
    this.getServiceAreaListing();
  },
  methods: {
    selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
    showAddForm() {
      this.showlist = false
    },
    callParent() {
      this.showlist = true;
      this.selectedEditRow = null;
      this.currentPage = 1;
      this.offset = 0;
      this.getServiceAreaListing();
    },
    async getServiceAreaListing(){
      try {
        let payload = {
          offset :    this.offset,
          limit : this.pageLimit
        }
        if(this.servicelevelSearch!=""){
          payload.servicelevelname = this.servicelevelSearch;
        }
        if(this.statusSearch!=""){
          payload.status = this.statusSearch;
        }

        this.isLoading = true;
        let result = await MasterService.getServiceLevelListing(payload);

        this.isLoading = false;
        this.totalCount = result.data.data.count;
        this.totalPage = Math.ceil(this.totalCount/this.pageLimit);
        this.apiListingData = result.data.data.rows
        this.tableItems = result.data.data.rows.map((el)=>{
          return {
            'id':el.id,
            'Template Name':el.servicelevelname,
            'Template Description': el.serviceleveldescription,
            'Route Mode': el.routemode,
            'Service Type' : el.servicetype == 1 ? 'City to City' : 'Zone to zone',
            'Created By':el.createdby,
            'Created Date':Util.displayDateTimeFormat(el.createddate),
            'Last Modified By':el.lastmodifiedby,
            'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
            'Status':el.status,
            'Action':'View Edit',
            'innerTableInfo':{
            }
          }
        })
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    async activeAction(data){
      try {
        this.isLoading = true;
        var item = this.apiListingData.find(item => item.id === data.id);
        var isactivestatus = item.status == 0 ? 1 : 0
        let inputPayload = {
          "id": data.id,
          "type": this.type,
          "status": isactivestatus
        }
        let result = await MasterService.changeStatus(inputPayload)
        if(result.data.code == 200){
          if(result.data.data[0].status == 0){
          this.$alert("Service Level Activated Successfully!!", this.serviceAreaName, "success");
        }else{
          this.$alert("Service Level Inactivated Successfully!!", this.serviceAreaName, "success");
         }
          this.getServiceAreaListing();
          this.isLoading = false;
        }
      } catch(err){
        console.log(err);
      }
    },
    getCustomTableEvent(event){
      if(event.actionType=="active"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       });
     }else if(event.actionType=="inactive"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       })
      }
      //console.log("Event Details", event);
      if(event.actionType == "edit") {
        let selectedEditRow  = this.apiListingData.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedEditRow = selectedEditRow[0];
        this.showlist = false;
      }
    },
    onPageChange(page) {
      this.currentPage = page;
       this.offset = (page - 1) *this.pageLimit
      this.getServiceAreaListing();
    },
    searchTemplateLevel(){
      this.currentPage = 1;
      this.servicelevelSearch= this.servicelevel;
      this.statusSearch= this.status;
      this.getServiceAreaListing();
    },
    resetTemplateLevel(){
      this.currentPage = 1;
      this.servicelevel= "";
      this.servicelevelSearch= "";
      this.status= "";
      this.statusSearch= "";
      this.statusitem = {};
      this.getServiceAreaListing();
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ServiceLevelTemplate/ServiceLevelListing/ServiceLevelListing.component.js